import React from "react";
import facebook from "../../assets/icons/facebook.png";
import github from "../../assets/icons/github.png";
import linkedin from "../../assets/icons/linkedin.png";
import twitter from "../../assets/icons/twitter.png";
import "./Banner.css";

const Banner = () => {
  return (
    <>
      <div>
        {/* <div className="hero min-h-screen bg-[url(https://avatars.githubusercontent.com/u/67538033)] md:bg-[url(https://i.ibb.co/phWf9wZ/cover.jpg)] bg-contain sm:bg-cover bg-no-repeat bg-fixed bg-bottom md:bg-center"> */}
        <div className="hero min-h-screen bg-[url(https://i.ibb.co/phWf9wZ/cover.jpg)] bg-cover bg-no-repeat bg-fixed bg-bottom md:bg-center">
          <div className="hero-overlay bg-opacity-60"></div>
          <div className="hero-content text-center text-neutral-content">
            <div className="max-w-2xl text-white -mt-56 md:-mt-24">
              <p className="text-2xl font-light mb-2 lg:text-3xl lg:mb-3">
                I'm
              </p>
              <h1 className="mb-5 md:mb-8 text-3xl sm:text-5xl lg:text-6xl font-medium">
                <span className="hover:text-success">A</span>
                <span className="hover:text-success">b</span>
                <span className="hover:text-success">d</span>
                <span className="hover:text-success">u</span>
                <span className="hover:text-success">l</span>
                <span className="hover:text-success">l</span>
                <span className="hover:text-success">a</span>
                <span className="hover:text-success">h</span>
                <span> </span>
                <span className="hover:text-success">A</span>
                <span className="hover:text-success">l</span>
                <span> </span>
                <span className="hover:text-success">N</span>
                <span className="hover:text-success">o</span>
                <span className="hover:text-success">m</span>
                <span className="hover:text-success">a</span>
                <span className="hover:text-success">n</span>
              </h1>
              <p className="text-xl font-light sm:text-2xl md:text-3xl mb-5">
                Web Developer
              </p>
              <div className="mx-auto text-center mb-8">
                <ul className="flex justify-center gap-5">
                  <li>
                    <a
                      href="https://www.linkedin.com/in/md-abdullahalnoman"
                      target="_blank"
                    >
                      <img
                        className="w-8 md:w-10 invert"
                        src={linkedin}
                        alt=""
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://github.com/devnoman01" target="_blank">
                      <img className="w-8 md:w-10 invert" src={github} alt="" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/devnoman01" target="_blank">
                      <img
                        className="w-8 md:w-10 invert"
                        src={twitter}
                        alt=""
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/Noman098" target="_blank">
                      <img
                        className="w-8 md:w-10 invert"
                        src={facebook}
                        alt=""
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <a
                href="#"
                className="btn btn-md bg-[#207561] border-0 text-white shadow hover:bg-white hover:text-[#207561]"
              >
                Download Resume
              </a>
              {/* <a
                href="https://drive.google.com/u/1/uc?id=17MjhVx9J7SDLjCrQrlMxnxyJVgqOs6BK&export=download"
                className="btn btn-md bg-[#207561] border-0 text-white shadow hover:bg-white hover:text-[#207561]"
              >
                Download Resume
              </a> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="waves"></div> */}
    </>
  );
};

export default Banner;
